'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var tslib = require('tslib');

function password(fieldConfig) {
    return {
        id: 'password',
        serverId: 'password',
        component: 'magic-ui-peek-password',
        isDataField: true,
        testId: 'step1-password',
        properties: {
            'placeholder': magicCommon.translate('sign-up-step-one.password.placeholder'),
            'unmask-password': fieldConfig.unmaskPassword,
        },
        validation: tslib.__spreadArray(tslib.__spreadArray([], passwordValidationConditions(fieldConfig.passwordValidationConditions)), [
            {
                name: 'notSameAsEmail',
                fn: function (field, _a) {
                    var email = _a.email;
                    var currEmail = email === null || email === void 0 ? void 0 : email.value;
                    return ((field || '').toLowerCase() !==
                        (currEmail || '').toLowerCase());
                },
                message: magicCommon.translate('sign-up-step-one.password.same-as-email-error'),
            },
        ]),
    };
}
function passwordValidationConditions(validationConditions) {
    return Object.entries(magicCommon.getPasswordValidationRules(validationConditions)).map(function (_a) {
        var name = _a[0], fn = _a[1];
        return ({
            name: name,
            fn: fn,
            message: magicCommon.translate('sign-up-step-one.password.error'),
        });
    });
}

exports.password = password;
